import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

export function onChangeTypeTable(style) {
  let response = {
    style: '',
    icon: '',
    text: '',
  }
  if (style == 'grid') {
    response.style = 'table'
    response.icon = 'icofont-calendar'
    response.text = 'Visualização em grade'
  } else {
    response.style = 'grid'
    response.icon = 'icofont-listing-box'
    response.text = 'Visualização em tabela'
  }
  return response
}

export function generatePdf(cadastros, selectEquipe, selectProfissional) {
  let title_pdf = 'Busca Ativa'
  let titlePdfSave = utils.methods.titlePdf(
    'Busca Ativa',
    selectEquipe.no_equipe
  )
  let description_pdf =
    'Sugestão de alguns dos cidadãos que estão com acompanhamento de saúde em atraso'
  let headers_pdf = ['NOME', 'NASCIMENTO', 'MÃE', 'MOTIVO', 'DOCUMENTO']
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.no_mae = cadastros[i].no_mae
    obj.motivo = cadastros[i].motivo
    let documentoText = ''
    if (cadastros[i].id !== null && cadastros[i].id !== undefined) {
      documentoText += `CPF / CNS ${cadastros[i].id}`
    }
    obj.documento = documentoText
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Profissional ACS',
            value: selectProfissional.no_profissional,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          doc.setTextColor(194, 10, 16) // vermelho

          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
export const dataFields = {
  Nome: 'no_cidadao',
  Nascimento: {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  Motivo: 'motivo',
}
